import * as actionTypes from './actionTypes';

export const openUpdateLeague=()=>({
    type:actionTypes.OPEN_UPDATE_LEAGUE
})

export const closeUpdateLeague=()=>({
    type:actionTypes.CLOSE_UPDATE_LEAGUE
})